import {
    Box,
    Flex,
    Text,
    SimpleGrid
} from "@chakra-ui/react";
import React from "react";
import { t } from "i18next";
import CustomSwitch from "./custom_switch";



const renderPermissionTile = (title, permissionKeys, permissions, togglePermission) => (
    <Box
        className="Total_Header Permission_Header"
        columns={{ base: 1 }}
    >
        <Box className="Total_Header_Left  Total_Header_Right">{t(title)}</Box>

        <SimpleGrid gap={2}
            columns={1}

            className="Permission_Content"
            style={{ marginInline: "5px" }}>

            {permissionKeys.map((key, index) => (
                <Flex

                    onClick={() => togglePermission(key)}
                     justify="space-between"

                     className={index < permissionKeys.length - 1 ? "Permission_Checkbox_Content" : ""}
                >
                    <Text fontSize="md">{t(key)}</Text>
                    <CustomSwitch

                        checked={permissions[key]}
                        onChange={() => togglePermission(key)}
                    />

                </Flex>
            ))}

        </SimpleGrid>
    </Box >
);

export default renderPermissionTile;
